// extracted by mini-css-extract-plugin
module.exports = {"prefooterBackground":"prefooter_prefooterBackground__l_Z7L","leftColumn":"prefooter_leftColumn__if4DN","rightColumn":"prefooter_rightColumn__5_DvW"};